import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import ProjectService, { ProjectsResponse } from '../../services/ProjectService'

export const useProjects = () => {
  const { org } = useParams()
  return useQuery<ProjectsResponse>({
    queryKey: ['projects', org],
    queryFn: () => ProjectService.listProjects(org!),
    enabled: !!org,
  })
}
